export const USERNAME = "username";
export const TOKEN = "token";
